<template>
  <!-- Links de verdade: ctrl+clique abre em outra aba. O título do grupo vem antes do primeiro item
       de cada grupo — no menu do Configurar, "Coleções" e "Ambiente", que são de espécies diferentes. -->
  <template v-for="(item, i) of items" :key="item.key">
    <v-list-subheader v-if="item.group && item.group !== items[i - 1]?.group">
      {{ item.group }}
    </v-list-subheader>
    <v-list-item :to="item.to" :title="item.title"/>
  </template>
</template>

<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'
import {RouteLocationRaw} from 'vue-router'

/**
 * Um item do menu: o título, para onde leva e, se quiser, o grupo, cujo título aparece antes do primeiro
 * item dele. Sem ícone por item: o grupo já diz por escrito o que cada parte é (escolha do usuário).
 */
export type MenuItem = { key: string, title: string, to: RouteLocationRaw, group?: string }

/**
 * As linhas de um menu de links, com o título de cada grupo — dentro do `v-list` de quem o hospeda.
 *
 * Um componente porque são dois a desenhá-las: o menu da barra (`BarMenu`), e o ⋮ do telefone
 * (`NavDestinations`), para onde o Configurar vai quando a barra não tem largura (pedido do usuário).
 * Escrita nos dois, a regra do título do grupo divergiria na primeira mudança.
 */
@Component({name: 'ontos-menu-items'})
class MenuItems extends Vue {
  @Prop({type: Array, required: true}) readonly items!: MenuItem[]
}

export default toNative(MenuItems)
</script>
